module.exports = __webpack_public_path__ + "63f35a28482a0e56731e6a4e7125b70c.fbx";